import { render } from "./SwitchView.vue?vue&type=template&id=08839c26"
import script from "./SwitchView.vue?vue&type=script&lang=js"
export * from "./SwitchView.vue?vue&type=script&lang=js"

import "./SwitchView.vue?vue&type=style&index=0&id=08839c26&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__